import type { ReactNode } from 'react';
import { Topbar } from './Topbar';

/**
 * Rahmen für die App-Innenseiten (Admin).
 *
 * Design-System §6: „App-Innenseiten: ruhig! Synthwave nur als Erinnerung
 * (Scanlines + bg-Verlauf), Fokus auf Daten." Der volle Synthwave-Hintergrund
 * bleibt Login und Homescreen vorbehalten.
 */
export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="page">
      <div className="bg-calm" aria-hidden="true" />
      <div className="bg__scanlines" aria-hidden="true" />
      <Topbar compact />
      <main className="page__main">
        <div className="container">{children}</div>
      </main>
    </div>
  );
}
